<template>
  <div class="input-group" v-bind="passthroughAttrs">
    <slot name="prepend" />
    <slot />
    <div v-if="$slots.append" class="input-group-append">
      <slot name="append" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdInputGroup',

  inheritAttrs: false,

  emits: [],

  computed: {
    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
